import { SchemaTypes } from '@allesauto/graphql';

export default function addressToAddressInput({
  salutation,
  firstName,
  lastName,
  street,
  houseNumber,
  additionalAddress,
  postalCode,
  city,
  phone,
  isDefaultShipping,
  isDefaultBilling,
}: SchemaTypes.CustomerAddress): SchemaTypes.CustomerAddressInput {
  return {
    salutation,
    firstName,
    lastName,
    street,
    houseNumber,
    additionalAddress,
    postalCode,
    city,
    phone,
    isDefaultShipping,
    isDefaultBilling,
  };
}
